<template>
    <div class="user">

        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <!-- <Button type="primary" class="add_user" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('user')}}</Button> -->
        </div>
        <Table border :columns="columns12" :data="data6">
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_edit_modal" :title="$t('edit')+$t('bank')" @on-ok="edit_bank">
            <Form :model="modalEdit" :label-width="100">
                <FormItem :label="$t('vnd_balance')">
                    <Input type="number" v-model="modalEdit.vnd_balance"></Input>
                </FormItem>
                <FormItem :label="$t('banK_num')">
                    <Input v-model="modalEdit.banK_num"></Input>
                </FormItem>
                <FormItem :label="$t('open_bank')">
                    <Input v-model="modalEdit.open_bank"></Input>
                </FormItem>
                <FormItem :label="$t('cardholder_name')">
                    <Input v-model="modalEdit.cardholder_name"></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>


<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';

export default {
    data() {
        return {
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            search: "",
            columns12: [
                {
                    title: "ID",
                    key: "user_id"
                },
                {
                    title: this.$i18n.t('username'),
                    key: "username"
                },
                {
                    title: this.$i18n.t('mobile'),
                    width: 120,
                    key: "mobile"
                },
                {
                    title: 'Email',
                    width: 150,
                    key: "email",
                },
                {
                    title: this.$i18n.t('amount'),
                    key: "vnd_balance",
                },
                {
                    title: this.$i18n.t('userView.bankNumber'),
                    key: "banK_num",
                },
                {
                    title: this.$i18n.t('userView.bankName'),
                    key: "open_bank",
                },
                {
                    title: this.$i18n.t('userView.cardholderName'),
                    key: "cardholder_name",
                },
                {
                    title: this.$i18n.t('edit'),
                    width:100,
                    align: "center",
                    render: (h, params) => {
                        return h('Icon', {
                            props: {
                                type: 'md-create',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'green',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.editBank(params.row);
                                }
                            }
                        });
                    }
                }
            ],
            data6: [],
            modalEdit:{
                user_id:'',
                vnd_balance:'',
                banK_num:'',
                open_bank:'',
                cardholder_name:'',
            },
            show_edit_modal: false,
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            let path = this.search ? this.$path.user_search : this.$path.user;
            this.$get(path, {
                mobile: this.search,
                page: this.currentPage,
                type: "bank"
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        editBank(row) {
            this.modalEdit.user_id = row.user_id;
            this.modalEdit.vnd_balance = row.vnd_balance;
            this.modalEdit.banK_num = row.banK_num;
            this.modalEdit.open_bank = row.open_bank;
            this.modalEdit.cardholder_name = row.cardholder_name;
            this.show_edit_modal = true;
        },
        edit_bank() {
            this.$post(this.$path.user_edit, {
                user_id: this.modalEdit.user_id,
                vnd_balance: Number(this.modalEdit.vnd_balance),
                banK_num: this.modalEdit.banK_num,
                open_bank: this.modalEdit.open_bank,
                cardholder_name: this.modalEdit.cardholder_name
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
                else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        formatUTCTime(utcTimeString) {
            return formatUTC(utcTimeString, 8); // 使用东八区
        }
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/bank/detail.vue